module.exports = __webpack_public_path__ + "img/redTopBg.af7f6f45.png";